import API from './api';
import { Building } from './buildings';

export interface SuggestedBuildings {
  buildings: Building[];
}

export interface SuggestedBuildingsParams {
  limit?: number;
  offset?: number;
}

export const getRelatedBuildings = async (
  buildingId: number,
  params: SuggestedBuildingsParams = {}
): Promise<SuggestedBuildings> => {
  const urlParams = new URLSearchParams();
  Object.entries(params).forEach(
    ([key, value]) => value && urlParams.set(key, value)
  );
  return API.get(
    `${API.BASE_URL}/leasing/buildings/${buildingId}/related?${urlParams}`
  );
};

export const getSuggestedBuildings = async (
  city: string
): Promise<SuggestedBuildings> => {
  const urlParams = new URLSearchParams();
  urlParams.set('city', city);
  return {
    buildings: await API.get(
      `${API.BASE_URL}/leasing/buildings/suggested?${urlParams}`
    ),
  };
};
